import Vue from 'vue';

export default filter => Vue.$http
    .get('Wordboards', { params: filter });




// WEBPACK FOOTER //
// ./src/services/wordboard/get.js